export default __webpack_public_path__ + "static/65-e611142e26d4a08a5448c9f33690609d.gif";